export const contributorHeaderCopy = {
  fr: {
    nav: "Tâches",
    translate: "Traduire",
    more: "Plus",
    allTasks: "Toutes les tâches",
    speak: "Enregistrer",
    write: "Transcrire",
    verify: "Valider",
    earnings: "Gains",
    collection: "Collecte",
    home: "Accueil",
    tasks: "Tâches",
    profile: "Profil",
    website: "Site web",
    balance: "Vos gains disponibles : {amount}",
    myProfile: "Mon profil",
    myContributions: "Mes contributions",
    myEarnings: "Mes gains",
    leaderboard: "Classement",
    logout: "Se déconnecter",
    accountMenu: "Menu du compte",
  },
  en: {
    nav: "Tasks",
    translate: "Translate",
    more: "More",
    allTasks: "All tasks",
    speak: "Record",
    write: "Transcribe",
    verify: "Validate",
    earnings: "Earnings",
    collection: "Collection",
    home: "Home",
    tasks: "Tasks",
    profile: "Profile",
    website: "Website",
    balance: "Your available earnings: {amount}",
    myProfile: "My profile",
    myContributions: "My contributions",
    myEarnings: "My earnings",
    leaderboard: "Leaderboard",
    logout: "Log out",
    accountMenu: "Account menu",
  },
} as const;

export type ContributorHeaderCopy = { [K in keyof (typeof contributorHeaderCopy)["fr"]]: string };
